import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const c = a((e, r) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: r,
    ...e,
    image: (t) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...t,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4111",
              width: 22,
              height: 32,
              x: 13,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M33.58 40c-.41 0-.75-.34-.75-.75l.01-6.07c0-6.77-3.48-10.65-9.56-10.65h-3.59c-4.44-.01-6.69-2.1-6.69-6.23V8.75c0-.41.34-.75.75-.75s.75.34.75.75v7.55c0 3.31 1.55 4.72 5.19 4.72h3.59c6.92 0 11.06 4.54 11.06 12.15l-.01 6.07c0 .42-.34.76-.75.76"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4111)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
c.displayName = "AgencyChestIcon";
export {
  c as AgencyChestIcon,
  c as default
};
//# sourceMappingURL=index.js.map
